import { DATEFORMAT_FULL } from '@/defs/date'
import { type WPPostType } from '@/defs/wordpress'
import { formatDate } from '@/utils/formatUtil'

import { ArticleAuthorLink } from '../ArticleAuthorLink/ArticleAuthorLink'

import styles from './ArticleByline.module.scss'

type Props = {
  author: WPPostType['author']
  date?: string
}

export const ArticleByline = ({ author, date }: Props) =>
  author && (
    <div className={styles.container}>
      <ArticleAuthorLink className={styles.author} slug={author.slug}>
        {author.avatarUrl && (
          <span className={styles.avatar}>
            <img alt={`${author.name} Photo`} decoding='async' loading='lazy' src={author.avatarUrl} />
          </span>
        )}
        <span className={styles.name}>{author.name || 'EDHREC'}</span>
      </ArticleAuthorLink>
      {date && <p className={styles.date}>{formatDate(date, DATEFORMAT_FULL)}</p>}
    </div>
  )
